import React from 'react';
import { Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SessionLoading } from '../SessionBootstrap/styles';
import { RootState } from '../../state-management/store';
import { LOGIN, ROOT } from '../../navigation/constants';
import { EUserRole } from '../../types/user';

interface ProtectedRouteProps {
	children: React.ReactNode;
	allowedRoles?: EUserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
	const user = useSelector((state: RootState) => state.global.user);
	const sessionReady = useSelector((state: RootState) => state.global.sessionReady);

	if (!sessionReady) {
		return (
			<SessionLoading>
				<Typography color='text.secondary'>Cargando...</Typography>
			</SessionLoading>
		);
	}

	if (!user) {
		return <Navigate to={LOGIN} replace />;
	}

	if (allowedRoles && !allowedRoles.includes(user.role)) {
		return <Navigate to={ROOT} replace />;
	}

	return <>{children}</>;
};

export default ProtectedRoute;
